import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
  public mtds: Methods = new Methods();
  public token;
  public url: string;
  public headers;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }

    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  getInvoices(page = 1, perpage = 10, busqueda = ''): Observable<any> {
    return this.petition(`${this.url}/soinfo/listbystatus/Invoiced?page=${page}&perpage=${perpage}`);
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = new HttpParams().set('authorization', this.token);

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params.set('json', json);
    }

    if (type != null) {
      params = params.set('type', type);
    }

    return this._http.post(url, params.toString(), { headers: this.headers });
  }
}
